/**To view a specific Incident related detials, events and location on maps */

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  FaFileImage,
  FaFileVideo,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileAlt,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { saveAs } from 'file-saver';
import { getallBanksByRole, getAllRole, getbarches, getTaskConfigsURL, getThemeURL, getUsersFromAppByRole } from "../../../../Services/EndPoints";
import { postDataWithBody } from "../../../../Services/Services";
import { getData } from "../../../../Services/ProfileServices";
import MapWrapperForIncident from "../../../../Components/UiComponents/MapWrapper/MapWrapperForIncidents";

const ViewIncidentDetails = () => {
  const location = useLocation();
  // Image gallery state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [mediaList, setMediaList] = useState([]);
  const [IncidentCategories, setIncidentCategories] = useState([]);
  const [BanksList, setBanksList] = useState([]);
  const [SourceList, setSourceList] = useState([]);
  const [Branches, setBranches] = useState([]);
  const [RoleList, setRoleList] = useState([]);
  const [UserList, setUserList] = useState([]);

  const [showPreview, setShowPreview] = useState(false);
  //   const location = useLocation();
  const [zoomLevel, setZoomLevel] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  // Try to get data from location.state or fallback to sessionStorage
  const initialIncidentData =
    location.state?.data || JSON.parse(sessionStorage.getItem("incidentData"));

  const incidentData = initialIncidentData;
  useEffect(() => {
    fetchIncidentDetails();
    getUserProfile();
    fetchSourceDetails();
    fetchBranches();
    fetchAllRoles();
    getUserProfileForUserByRole()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Save to sessionStorage if it's coming from location.state
  useEffect(() => {
    if (location.state?.data) {
      sessionStorage.setItem(
        "incidentData",
        JSON.stringify(location.state.data)
      );
    }
  }, [location.state?.data]);

  // Initialize media list from incident data
  useEffect(() => {
    if (incidentData?.mediaList && incidentData.mediaList.length > 0) {
      setMediaList(incidentData.mediaList);
    } else {
      // Fallback to placeholder images if no media is available
      setMediaList([
        { mediaPath: "/api/placeholder/230/150", type: "INCIDENT_UPDATE" },
        { mediaPath: "/api/placeholder/230/150", type: "INCIDENT_UPDATE" },
        { mediaPath: "/api/placeholder/230/150", type: "INCIDENT_UPDATE" },
      ]);
    }
  }, [incidentData]);

  // Check if current media item is a video (based on path extension)
  const isCurrentItemVideo = () => {
    if (!mediaList[currentImageIndex]) return false;
    const path = mediaList[currentImageIndex].mediaPath.toLowerCase();
    return (
      path.endsWith(".mp4") || path.endsWith(".mov") || path.endsWith(".avi")
    );
  };
  let date = "N/A";
  let time = "N/A";

  if (incidentData?.incidentDateAndTime) {
    const dateTime = new Date(incidentData.incidentDateAndTime);
    if (!isNaN(dateTime)) {
      const dd = String(dateTime.getDate()).padStart(2, "0");
      const mm = String(dateTime.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const yy = String(dateTime.getFullYear()).slice(-2);
      date = `${dd}-${mm}-${yy}`;

      let hours = dateTime.getHours();
      const minutes = String(dateTime.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const formattedHours = String(hours).padStart(2, "0");

      time = `${formattedHours}:${minutes} ${ampm}`;
    }
  }

  const getUserProfileForUserByRole = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        getUserList(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayloadForUserByRole = (profile) => {
   if (profile.role_name === "SUPER ADMIN") {
      return {
        admin_role: "SA",
        bank_id: profile.bank_id || null,
        branch_id: profile.branch_id || null,
      };
    } else if (profile.is_admin === true) {
      return {
        admin_role: "HO",
        bank_id: profile.bank_id || null,
        userId: profile.id,
      };
    }
    else {
      return {
        admin_role: "U",
        bank_id: profile.bank_id || null,
        branch_id: profile.branch_id || null,
      };
    }
  };

  const getUserList = async (profile) => {
    // setLoader(true);
    try {
      const payload = createPayloadForUserByRole(profile);
      const fetchedUsers = await postDataWithBody(getUsersFromAppByRole, payload, {});
      const sortedUsers = fetchedUsers.sort((a, b) =>
        a.first_name > b.first_name ? 1 : -1
      );
      const userList = sortedUsers.map((user) => ({
        label: `${user.first_name} ${user.last_name}`,
        value: user.id,
        created_by: user.created_by, // Make sure this field is captured
      }));
      setUserList(userList);
    } catch (error) {
      console.error("Error fetching user list:", error);
      toast.error("Failed to load user list");
    } finally {
      // setLoader(false);
    }
  };

  const getFileIcon = (fileType) => {
    const iconStyle = { fontSize: "55px", color: "#1a7a73" };
    switch (fileType) {
      case "image/jpeg":
      case "image/jpg":
      case "image/png":
        return <FaFileImage />;
      case "video/mp4":
        return <FaFileVideo />;
      case "application/pdf":
        return <FaFilePdf />;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return <FaFileWord />;
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return <FaFileExcel />;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return <FaFilePowerpoint />;
      default:
        return <FaFileAlt style={iconStyle} />;
    }
  };
  // Function to display data or N/A if not available
  const displayData = (data) => data || "N/A";

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    // Format the date part as dd-mm-yy
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).toString().slice(-2);

    // Format the time part as HH:mm AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    const formattedHours = String(hours).padStart(2, "0");

    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

    return `${dd}-${mm}-${yy} ${formattedTime}`;
  };

  // Get the criticality color based on severity level
  // const getCriticalityColor = (severity) => {
  //   let textColor;
  //   switch (severity?.toUpperCase()) {
  //     case "HIGH":
  //       textColor = "#FF5D30";
  //       break;
  //     case "MEDIUM":
  //       textColor = "#FFA100";
  //       break;
  //     case "LOW":
  //       textColor = "#40BAC2";
  //       break;
  //     default:
  //       textColor = "#808080";
  //   }
  //   return textColor;
  // };

  // Get styling for the current incident
 // const criticalityColor = getCriticalityColor(incidentData?.severityLevel);

// Map configuration for MapWrapper
const mapTitle = "Incident Location";
const mapCoordinates = [
  {
    x: incidentData?.latitude || 25.4223,
    y: incidentData?.longitude || 86.1391,
    locationId: 1,
    popupdata: {
      title: incidentData?.incidentName,
      incdescription: incidentData?.description, // Incident description
      status: incidentData?.status,
      type: "Incident",
      // Additional fields for the popup
      incidentCategory: IncidentCategories.find(
        cat => cat.id === incidentData?.incidentCategoryId
      )?.value || "N/A",
      severity: incidentData?.severityLevel || "N/A",
      // Add media data to popup
      mediaList: mediaList.filter(
        media => media.type === "INCIDENT_CREATE" || media.type === "INCIDENT_UPDATE"
      ),
    },
  },
];
  // Handler for recording chosen coordinates if needed
  const handleChooseCoordinates = (longitude, latitude) => {
    console.log(`Selected coordinates: ${longitude}, ${latitude}`);
  };

  const fetchIncidentDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["INCDNT_CAT"],
        {}
      );

      if (response && Array.isArray(response)) {
        setIncidentCategories(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
   let admin_role;
 
    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }
 
    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  //To fetch banks list
  const fetchBanks = async (profile) => {
    // setLoader(true);
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    } finally {
      // setLoader(false);
    }
  };

  //To fetch incident category
  const fetchSourceDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["BRCH_SRC_SYS_ORG"],
        {}
      );

      if (response && Array.isArray(response)) {
        // Store the incident categories in state
        setSourceList(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  //fetching branches based on the bank selection
  const fetchBranches = async () => {
    try {
      const response = await getData(
        getbarches.replace("ID", incidentData.bankId)
      );
      setBranches(response);
    } catch (error) {
      console.error("Error fetching branches:", error);
      toast.error("Failed to load branches data");
    }
  };

  const fetchAllRoles = async () => {
    try {
      const rolearr = await getData(getAllRole);
      const sortedRoles = rolearr.sort((a, b) => (a.name > b.name ? 1 : -1));

      const roleList = sortedRoles.map((role) => ({
        label: role.name,
        value: role.id,
      }));

      setRoleList(roleList);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles");
    } finally {
    }
  };

  const handleDownload = (media) => {
    console.log("media", media)
    // Fetch the file from media.mediaPath if it's a URL or directly use Blob if it's already in memory.
    fetch(media.mediaPath)
      .then(response => response.blob())
      .then(blob => {
        // Use file-saver to download the file
        saveAs(blob, media.name || "download");
      })
      .catch(err => console.error('Error downloading the file:', err));
  };

  const hasMedia = mediaList.some((media) => {
    const mediaPath = media.mediaPath?.toLowerCase() || "";
    return (
      mediaPath.endsWith(".jpg") ||
      mediaPath.endsWith(".jpeg") ||
      mediaPath.endsWith(".png") ||
      mediaPath.endsWith(".gif") ||
      mediaPath.endsWith(".mp4") ||
      mediaPath.endsWith(".mov") ||
      mediaPath.endsWith(".avi") ||
      mediaPath.endsWith(".pdf") ||
      mediaPath.endsWith(".doc") ||
      mediaPath.endsWith(".docx") ||
      mediaPath.endsWith(".xls") ||
      mediaPath.endsWith(".xlsx") ||
      mediaPath.endsWith(".ppt") ||
      mediaPath.endsWith(".pptx")
    );
  });

  //To handle image preview
  const handleImageClick = () => {
    setZoomLevel((prevZoom) => (prevZoom === 1 ? 2 : 1)); // Toggle between 100% and 200% zoom
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setStartPos({ x: e.clientX, y: e.clientY });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const dx = e.clientX - startPos.x;
    const dy = e.clientY - startPos.y;

    setPosition((prevPos) => ({
      x: prevPos.x + dx,
      y: prevPos.y + dy,
    }));

    setStartPos({ x: e.clientX, y: e.clientY });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  return (
    <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
      <div className="row g-0" style={{ height: "130vh", overflow: "hidden" }}>
        {/* Left Panel - Event Details with scrollbar */}
        <div className="col-md-6 p-4 bg-white" style={{ height: "100vh" }}>
          {/* Grid Layout for Event Details - 3 columns with reduced spacing */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            {/* First row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Incident ID
              </p>
              <p className="mb-0">{displayData(incidentData?.incidentId)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Incident Name
              </p>
              <p className="mb-0">{displayData(incidentData?.incidentName)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Incident Category
              </p>
              <p className="mb-0">
                {displayData(
                  IncidentCategories.find(
                    (cat) => cat.id === incidentData?.incidentCategoryId
                  )?.value
                )}
              </p>
            </div>

            {/* Second row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Incident Date & Time
              </p>
              <div>
                <p className="mb-0">{date}</p>
                <p className="mb-0">{time}</p>
              </div>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Severity
              </p>
              <div className="mb-0">
                {displayData(incidentData?.severityLevel)}
              </div>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Bank Name
              </p>
              <p className="mb-0">
                {" "}
                {displayData(
                  BanksList.find((cat) => cat.id === incidentData?.bankId)
                    ?.bankName
                )}
              </p>
            </div>

            {/* Third row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Branch Name
              </p>
              <p className="mb-0">
                {" "}
                {displayData(
                  Branches.find((cat) => cat.id === incidentData?.branchId)
                    ?.branchName
                )}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Created on
              </p>
              <p className="mb-0">{formatDateTime(incidentData?.created_on)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Created by
              </p>
              <p className="mb-0">
                {displayData(
                  UserList.find(
                    (cat) => cat.value === incidentData?.createdBy
                  )?.label
                )}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Updated on
              </p>
              <p className="mb-0">{formatDateTime(incidentData?.updated_on)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Updated by
              </p>
              <p className="mb-0">
                {displayData(
                  UserList.find(
                    (cat) => cat.value === incidentData?.updated_by
                  )?.label
                )}
              </p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Source
              </p>
              <p className="mb-0">
                {" "}
                {displayData(
                  SourceList.find((cat) => cat.id === incidentData?.sourceId)
                    ?.value
                )}
              </p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Affected Services
              </p>
              <p className="mb-0">
                {displayData(incidentData?.affectedServices)}
              </p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                SLA Target
              </p>
              <p className="mb-0">{displayData(incidentData?.slaTarget)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Assigned Team
              </p>
              {/* eslint-disable-next-line eqeqeq */}
              <p className="mb-0">
                {displayData(
                  incidentData?.assignedTeam
                    ?.split(",")
                    .map(
                      (team) => RoleList.find((cat) => cat.value == team)?.label
                    )
                    .filter(Boolean)
                    .join(", ")
                )}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Reporter Name
              </p>
              <p className="mb-0">{displayData(incidentData?.reporterName)}</p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Reporter Mobile/ Landline Number
              </p>
              <p className="mb-0">{displayData(incidentData?.reporterPhone)}</p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Reported Date & Time
              </p>
              <p className="mb-0">
                {formatDateTime(incidentData?.reportedDate)}
              </p>
            </div>
          </div>

          {/* Description - Full width */}
          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Incident Description
              </p>
              <p className="mb-0">{displayData(incidentData?.description)}</p>
            </div>
          </div>

          {/* Images & Videos Section */}
          {/* Attachments Section with Download Icon */}
          <div className="row mb-3">
            <div className="col-12">
              <p
                className="mb-2 d-flex align-items-center"
                style={{ color: "#1a7a73", fontSize: "15px" }}
              >
                Attachments (Images, Videos & Documents )
              </p>

              {(() => {
                // Filter media list at the component level
                const filteredMediaList = mediaList.filter(
                  (media) => media.type === "INCIDENT_CREATE" || media.type === "INCIDENT_UPDATE"
                );

                if (hasMedia && filteredMediaList.length > 0) {
                  return (
                    <div
                      className="d-flex flex-wrap"
                      style={{
                        marginBottom: "20px",
                        gap: "10px",
                        overflowX: "auto",
                      }}
                    >
                      {filteredMediaList.map((media, index) => {
                        console.log("media", media);
                        const mediaPath = media.mediaPath?.toLowerCase() || "";
                        const isImage = /\.(jpg|jpeg|png|gif)$/i.test(mediaPath);

                        const url = media.fileName || "";
                        const name = url.split("/").pop(); // Get just the file name
                        console.log("Full name:", name);

                        const dotIndex = name.lastIndexOf(".");
                        const nameWithoutExtension = dotIndex !== -1 ? name.substring(0, dotIndex) : name;

                        console.log("Name without extension:", nameWithoutExtension);

                        return (
                          <div
                            key={index}
                            className="position-relative"
                            style={{
                              width: "100px",
                              textAlign: "center",
                            }}
                          >
                            {isImage ? (
                              <div
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "4px",
                                  overflow: "hidden",
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setCurrentImageIndex(index);
                                  setShowPreview(true);
                                }}
                              >
                                <img
                                  src={media.mediaPath}
                                  alt={`Media ${index + 1}`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    opacity: index === currentImageIndex ? 1 : 0.7,
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "4px",
                                  backgroundColor: "#f0f0f0",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDownload(media)}  // Trigger the download on click
                              >
                                {getFileIcon(media.mediaPath)}
                              </div>
                            )}

                            <span
                              style={{
                                display: "block",
                                fontSize: "12px",
                                marginTop: "4px",
                                wordWrap: "break-word",
                                whiteSpace: "normal",
                              }}
                              title={name}
                            >
                              {nameWithoutExtension}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  );
                } else {
                  return <p className="text-muted">No images available</p>;
                }
              })()}
            </div>
          </div>
        </div>

        {/* Right Panel - Map with MapWrapper component */}
        <div className="col-md-6 p-0" style={{ overflow: "hidden" }}>
          <MapWrapperForIncident
            title={mapTitle}
            containerStyles={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
            headerStyles={{
              backgroundColor: "#1a7a73",
              color: "white",
              padding: "8px 16px",
              height: "40px",
            }}
            bodyStyles={{
              flex: 1,
              overflow: "hidden",
            }}
            coordinates={mapCoordinates}
            chooseCoordinates={handleChooseCoordinates}
            zoom={13}
            popUpShow={true}
          />
        </div>
      </div>
      {showPreview && (() => {
        // Filter media list for the preview section
        const filteredMediaList = mediaList.filter(
          (media) => media.type === "INCIDENT_CREATE" || media.type === "INCIDENT_UPDATE"
        );

        return (
          <div
            role="dialog"
            aria-modal="true"
            onClick={() => setShowPreview(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center", // Changed to center for full screen experience
              zIndex: 9999,
            }}
          >
            <div
              style={{
                position: "relative",
                width: "95vw", // Almost full width
                height: "90vh", // Almost full height
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Circle close button */}
              <button
                onClick={() => setShowPreview(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "22px",
                  lineHeight: "36px",
                  textAlign: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  zIndex: 10000, // Ensure it's above everything else
                }}
                aria-label="Close"
              >
                &times;
              </button>

              {/* Media container */}
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  overflow: "auto", // Changed to auto to allow scrolling if needed
                  width: "100%",
                  height: "100%", // Take full height of parent
                  boxSizing: "border-box",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: zoomLevel > 1 ? "grab" : "auto",
                  userSelect: "none",
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
              >
                {isCurrentItemVideo() ? (
                  <video
                    controls
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%", // Ensure video fits in container
                      borderRadius: "8px",
                    }}
                  >
                    <source src={filteredMediaList[currentImageIndex]?.mediaPath} />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={filteredMediaList[currentImageIndex]?.mediaPath}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%", // Ensure image fits in container
                      objectFit: "contain",
                      transform: `scale(${zoomLevel}) translate(${position.x}px, ${position.y}px)`,
                      transition: "transform 0.3s ease-in-out",
                      cursor: zoomLevel > 1 ? "grab" : "zoom-in",
                      borderRadius: "8px",
                    }}
                    onClick={handleImageClick}
                  />
                )}
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default ViewIncidentDetails;
